module.exports = {
    global: {
      whatsapp: 'https://wa.link/nhyihm'
    }
  };